import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import moStaffTrend, { changeType } from './store/index';
import Income from '../../component/income';
import NewIncome from '../../component/new-income';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import { exportExcelFile } from '@/tool';
import moMenu from '../../store/menu';

interface IProps { }
interface IState { }

const StuffTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, adminX, adminY, empty,
    financeX, financeY, techX, techY,
    produceX, produceY, saleX, saleY,
    tableTitle, tableList, overview,
  } = moStaffTrend;

  const exporttable = () => {
    const head:any = [
      ['年份', '生产/工程人员', '技术人员占比', '销售人员占比', '财务人员占比', '行政人员占比'],
    ];
    const list:any = [...head, ...tableList];
    const merge:any = [];
    exportExcelFile(list, merge, '员工构成时间趋势');
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect14" className="stuff-trend_10 box-111">
      <SubTitle title="员工构成时间趋势" subtitle={moMenu.industryName} active={type}
        bg={Color.primaryColor(0.1)} color={Color.primary}
        tabChange={(val: string) => changeType(val)}
        contentList={['人员构成占比的计算方式：将该行业下所有样本公司的该类型员工数加总，然后除以所有样本公司的员工数加总。']} />

      {type === 'chart' ? (
        <section className="trend-1511">
          {!empty ? (
            <>
              <section className="trend-1515">
                <section className="trend-6060 trend-6066">
                  <p className="line-1011 line-1199"><strong>生产/工程人员</strong></p>
                  <Income height={300} xData={produceX} yData={produceY} name="生产/工程人员"
                    bgColor={Color.d9Color(0.05)} />
                </section>
              </section>
              <section className="trend-1515">
                <section className="trend-6060 trend-6066">
                  <p className="line-1011 line-1199"><strong>技术人员占比</strong></p>
                  <NewIncome height={300} xData={techX} yData={techY} name="技术人员占比"
                    bgColor={Color.secondaryColor(0.05)} />
                </section>
              </section>
              <section className="trend-1515">
                <section className="trend-6060 trend-6066">
                  <p className="line-1011 line-1199"><strong>销售人员占比</strong></p>
                  <NewIncome height={300} xData={saleX} yData={saleY} name="销售人员占比"
                    bgColor={Color.twoColor(0.05)} />
                </section>
              </section>
              <section className="trend-1515">
                <section className="trend-6060 trend-6066">
                  <p className="line-1011 line-1199"><strong>财务人员占比</strong></p>
                  <Income height={300} xData={financeX} yData={financeY} name="财务人员占比"
                    bgColor={Color.d9Color(0.05)} />
                </section>
              </section>
              <section className="trend-1515">
                <section className="trend-6060 trend-6066">
                  <p className="line-1011 line-1199"><strong>行政人员占比</strong></p>
                  <NewIncome height={300} xData={adminX} yData={adminY} name="行政人员占比"
                    bgColor={Color.secondaryColor(0.05)} />
                </section>
              </section>
              <section className="chart-detail_11 industry-detail_11"
                style={{ width: '100%', marginTop: '26px', height: 'auto' }}>
                {overview.map((item: any, index: number) => (
                  <section key={index} className="item">
                    <span className="circle-111"><b /></span>
                    <p className="line-111">
                      {item.map((child: any, idx: number) => (
                        <Fragment key={idx}>
                          {child.mark === 'number' ? (
                            <span className="blue-11">{child.value}</span>
                          ) : null}
                          {child.mark === 'change_ratio' ? (
                            <>
                              {child.value >= 0 ? (
                                <span className="red-11">{`${round(child.value * 100, 1)}%`}</span>
                              ) : (
                                <span className="green-11">{`${round(child.value * 100, 1)}%`}</span>
                              )}
                            </>
                          ) : null}
                          {(child.mark !== 'number' && child.mark !== 'change_ratio') ? (
                            <span className="span-11">{child.value}</span>
                          ) : null}
                        </Fragment>
                      ))}
                    </p>
                  </section>
                ))}
              </section>
            </>
          ) : (
            <Empty />
          )}
        </section>
      ) : (
        <section className="content-151">
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!empty ? <CommonTable titleList={tableTitle} list={tableList} /> : <Empty />}
        </section>
      )}
    </section>
  );
};

export default observer(StuffTrend);
